
const Termos = () => {
    return <div style={{height: "100vh", minHeight: 400}} className="p-5 d-flex row">
        <div className="h-75">
            <h2 className="font-weight-bold text-center" >TERMO DE CIÊNCIA E CONCORDÂNCIA </h2> <br />
            <p style={{ textAlign: "justify" }}>
                A LEV INTERMEDIAÇÃO DE NEGÓCIOS LTDA declara que arcará uma única vez com os custos de
                frete e envio dos brindes adquiridos pelos agentes por meio do LEV MILHAS, plataforma de
                pontuação e troca de produtos, destinada aos funcionários da Lev (matriz e filiais), bem como aos
                agentes de vendas cadastrados na Lev.
                Entretanto, caso haja devolução do produto por qualquer motivo (endereço incorreto, logradouro
                com numeração incorreta, cliente ausente na entrega, pacote não retirado na agência dos Correios,
                extravio, etc.), o reenvio do brinde será custeado pelo Gerente Comercial responsável pelo agente
                gratificado.

            </p>
        </div>
        <div className="font-weight-bold h-25" style={{ fontSize: 11, color: "#512d6d" }}>
            <div className="text-center">DEPARTAMENTO JURÍDICO</div>
            <div className="text-center">LEV INTERMEDIACAO DE NEGOCIOS LTDA | CNPJ 13.054.592/0001-76</div>
            <div className="text-center">Avenida Frei Germano, 2300 – Estação, Franca/SP – CEP 14.405-215</div>
            <div className="text-center">Telefone: (16) 3712-5600 | juridico@levnegocios.com.br</div>
        </div>
    </div>
}

export default Termos;